export default __webpack_public_path__ + "46025266e22d1166efa7a277870cf8a3.svg";